<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size menu_size">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>Overall</i>
                </dt>
                <dd>
                    <div v-if="!loading" class="allmenu_wrap">
                        <dl v-for="(menu, i) in allMenuList" :key="menu.menuId">
                            <dt>
                                {{ menu.menuNm }}
                            </dt>
                            <dd v-if="menu.groupMenu">
                                <ul class="group" v-for="groups in menu.groupMenu">
                                    <li v-if="gMenu.subMenu.length === 0" v-for="gMenu in groups">
                                        <a href="javascript:" @click="moveMenu(gMenu)">{{ gMenu.menuNm }}</a>
                                    </li>
                                    <li v-if="gMenu.subMenu.length > 0" v-for="gMenu in groups" class="dir">
                                        <a href="javascript:" :menuId="gMenu.menuId" @click="clickParent($event)">{{ gMenu.menuNm }}</a>
                                        <ul class="sub_group">
                                            <li v-if="sub.subMenu.length === 0" v-for="sub in gMenu.subMenu">
                                                <a href="javascript:" @click="moveMenu(sub)">{{ sub.menuNm }}</a>
                                            </li>
                                            <li v-if="sub.subMenu.length > 0" v-for="sub in gMenu.subMenu" class="dir">
                                                <a href="javascript:" :menuId="sub.menuId" @click="clickParent($event)">{{ sub.menuNm }}</a>
                                                <ul class="sub_group">
                                                    <li v-for="ssub in sub.subMenu">
                                                        <a href="javascript:" @click="moveMenu(ssub)">{{ ssub.menuNm }}</a>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="$emit('close')">{{
                                $t('BUTTON.GLOBAL.CLOSE')
                            }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import axios                    from 'axios';
import qs                       from 'query-string';
import store                    from '@/vuex/store';
import SDLLocale                from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil }    from '@/utils';
import { EventBus }             from '@/utils/EventBus';

const updateMenuHistory = menuForm => axios.post(
    `${SDLUtil.API_URL}/basis/common/saveMenuLog.skp`,
    qs.stringify(menuForm),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'GnbAllMenuPopup',
    data(){
        return {
            loading: true,
            userInfo: null,
            menuList: [],
            allMenuList: [],

            selMenuId: '',
            selMenuList: []
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            allMenus: 'getMenus',
            loginSystem: 'getLoginSystem',
            storeParams: 'getParams'
        }),
    },
    watch: {
        // 메뉴 아이디가 선택되면 이벤트 실행
        selMenuId() { this.setBreadcrumbs(); }
    },
    methods : {
        topMenus() {
            if(this.menus) {
                let sortedMenus = _.sortBy(this.menus.filter(menu => menu.menuLevel == 1 && menu.subMenu.length > 0), ['sort3']);
                return _.dropRightWhile(sortedMenus, [ 'menuId', 'TOP_1000000003' ]);

            } else {
                return [];
            }
        },
        getRefineMenu() {
            // vuex 에 메뉴가 있으면 재정의한다.
            if(this.allMenus) {
                let refineMenus = [];
                const originMenu = this.topMenus();

                // 메뉴 루프 시작
                for(let idx = 0; idx < originMenu.length; idx++) {
                    let refineMenu = originMenu[idx];
                    let subMenu = refineMenu.subMenu;
                    let groupList = [], oldCd = 'NA';

                    // 메뉴 서브가 존재할 시
                    if(subMenu.length > 0) {
                        let group = [];
                        for(let i = 0; i < subMenu.length; i++) {
                            let sortSubMenu = subMenu[i];
                            let menuGrpCd = SDLUtil.nvl(sortSubMenu['menuGroupCd'], 'NA');
                            if(i === 0) {
                                group.push(sortSubMenu);

                            } else {
                                if(oldCd !== menuGrpCd) {
                                    groupList.push(group);
                                    group = [];
                                }

                                group.push(sortSubMenu);
                            }

                            oldCd = menuGrpCd;

                            if(i === (subMenu.length - 1)) {
                                groupList.push(group);
                            }
                        }

                        refineMenu.groupMenu = groupList;
                    }

                    refineMenus.push(refineMenu);
                };

                return refineMenus;

            } else {
                return [];
            }
        },
        // 메뉴 이동 - 메인으로 이동 시 Support 와 일반의 메뉴 이동은 다르게 이동된다.
        moveMenu(menu) {
            if(typeof menu === "undefined") {
                store.commit( 'PARAMS', Object.assign( this.storeParams, { menuId : '', menuGrpCd : '', menuGrpDetailCd : '', creationYn : null } ) );
                if(this.loginSystem == 'SUPPORT') {
                    this.$router.push(MenuUtil.getSupportMain());
                } else {
                    this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
                }

            } else {
                this.selMenuId = menu.menuId;
                let connUrl = menu.connUrl.replace('.skp', '');
                this.$log.info('▶ GnbAllMenuPopup.vue Selected url => ', connUrl);

                store.commit(
                    'PARAMS',
                    Object.assign(
                        this.storeParams,
                        {
                            menuId : menu.menuId,
                            menuPid : menu.menuPid || '',
                            menuGrpCd : menu.menuGroupCd || '',
                            menuGrpDetailCd : menu.menuGroupDetailCd || '',
                            creationYn : menu.creationYn
                        }
                    )
                );

                this.$router.push(connUrl);
            };

            EventBus.$emit('my-menus-reload');
        },
        setBreadcrumbs() {
            if(!SDLUtil.isNull(this.selMenuId)) {
                let scanMenu = MenuUtil.menuScan(this.selMenuId, this.menus), breads = [];
                scanMenu.forEach((menu) => { if(menu.currMenu){ this.boardId = menu.menuNm; breads.push(menu); } });
                for(let i = 0; i < breads[0].depth; i++){
                    let menuPid = breads[i].menuPid;
                    scanMenu.forEach((menu) => { if(menuPid === menu.menuId) breads.push(menu); });
                }

                this.selMenuList = _.sortBy(breads, ['depth']);
                this.updateMenu(this.selMenuId);

            } else {
                this.selMenuList = [];
            }
        },
        // 메뉴 이력 업데이트
        async updateMenu(selMenuId) {
            if(this.selMenuList.length > 0) {
                let menuForm = { menuId : (selMenuId || '') };
                if(!SDLUtil.isNull(menuForm.menuId)) {
                    return await updateMenuHistory(menuForm);
                }
            }
        },
        clickParent(e) {
            if( e.target.closest('li').classList.contains('active') ) {
                e.target.closest('li').classList.remove('active');

            } else {
                e.target.parentNode.classList.remove('active');
                e.target.closest('li').classList.add('active');
            };
        }
    },
    created() {
        SDLUtil.showLoadingBar(true);
        this.allMenuList = this.getRefineMenu();
    },
    mounted() {
        SDLUtil.showLoadingBar(false);
        this.$nextTick(() => {
            this.loading = false;
        });
    },
    beforeDestroy() {

    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/GnbAllMenuPopup.vue